export default function (event: Cinch.AnalyticsEvent) {
  if (!event) {
    return
  }

  if (typeof document !== 'undefined') {
    const el = document.body
    const newEvent = new CustomEvent(event.name, {
      bubbles: true,
      detail: event.details || {},
    })
    el.dispatchEvent(newEvent)

    return newEvent
  }
}
